import { render, staticRenderFns } from "./RefundsList.vue?vue&type=template&id=5f82b906&scoped=true&"
import script from "./RefundsList.vue?vue&type=script&lang=ts&"
export * from "./RefundsList.vue?vue&type=script&lang=ts&"
import style0 from "./RefundsList.vue?vue&type=style&index=0&id=5f82b906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f82b906",
  null
  
)

export default component.exports